import * as service from './chemicalrecord.service.js'
export default {
  data() {
    let context = this
    return {

      allowSubmit: true, //HERE BECAUSE NORMAL VALIDATE CHANNELS DON'T SEEM TO WORK FOR MY FORM

      Chemicalcolumns: ['AddedOn', 'LocationName', 'LogTemplateName', 'AddedBy', 'IsAlertRange', 'Actions'],
      isload: false,
      isEmpty: false,
      optionstable: {
        skin: this.$hydrowareCommonJS.hydrowareTableSkin,
        headings: {
          LocationName: 'Aquatic Facility',
          LogTemplateName: 'Template',
          AddedBy: 'Entered by',
          AddedOn: 'Entered on',
          IsAlertRange: 'In Range/Complete',
          Actions: ''
        },

        columnsClasses: {
          "Actions":"hydroware-2-button-column",
          "AddedOn":"hydroware-datetime-column",
          "LocationName":"hydroware-facility-column hidden-xs hidden-sm",
          "IsAlertRange":"hidden-xs hidden-sm hidden-md",
          "AddedBy":"hidden-xs hidden-sm hidden-md"
        },

        sortable: [],
        sortIcon: this.$hydrowareCommonJS.SortIcons,
        orderBy: {
          ascending: true
        },
        texts: {
          filterPlaceholder: 'Search...',
         limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },
      Locations: [],
      StandardCodeName: '',
      Firstloading: false,
      isnull: false,
      countlength: '',

      loadmore: {
        skip: 0,
        take: 10
      },
      headerLocationName: '',
      Isenabled: false,
      locationName: '',
      locationNamed: '',
      chemicalRecords: [],
      recordBackup: [],
      listRecord: true,
      addRecord: false,
      addRecordbutton: true,

      isAddingOrEditing: '', //FG - After Cert - First Release Security (7) Added this variable, it will be set to either "A" or "E" when adding or editing

      chemicalRecordDetails: [],
      checklists: [],
      checklistName: '',
      cheklistLocation: '',
      chemicalDetails: [],
      cheklistStandard: [],
      standards: [],
      pools: [],
      cheklistPool: '',
      recordForm: {
        Id: '',
        StandardCodeId: '',
        ChemicalChecklistId: '',
        PoolId: '',
        Notes: '',
        ChemicalRecordValues: []

      },
      templateForm: {
        LogTemplateId: '',
        TemplateReadings: [],
        TemplateMaintenance: [],
        TemplateTasks: [],
        TemplateNotes: []

      },
      templateForUpload: {
        Id: '',
        LogTemplateId: '',
        TemplateReadings: [],
        TemplateMaintenance: [], //when data is uploaded the TemplateTasks from the templateForm are pushed into this array
        TemplateNotes: []

      },
      editableTabs: [],
      templateName: '',
      qid: '',
      isDashboardView: false
      
    }
  },
  mounted() {

//this.$el.querySelector('.VueTables__limit').hidden = true

    this.GetLocations()
    let context = this

    if (this.$route.query.id) {

      this.qid = this.$route.query.id
      this.GetChemicalRecordDetails(this.$route.query.id)
      context.isDashboardView = true
    } else {
      this.$router.app.$on('emittedlocation_obj', (data) => {
        context.isDashboardView = false
        context.locationName = data.LocationId ? data.LocationId : ''
        context.locationNamed = data.LocationName ? ' - ' + data.LocationName : ''

        if (context.locationName) {

          context.GetChemicalRecords(context.locationName)
        }

        // alert(JSON.stringify(data))

      })
    }
  },
  beforeDestroy() {

    //this.$root.$off('emittedlocation_obj')  //FG - FOOF - Jan 23 2019
  },
  methods: {
    maintCheckboxChanged(maint) {
      //FG - FOOF - TWO THINGS:
      //1) I could not get the validation rules to trigger when one of the custom buttons
      //was clicked so this is my hack
      //2) I'm sure there is a better way to do the validation but I
      //couldn't get the validation to work on the form item alone so I finally
      //gave up and I just validate the entire form.
      this.validateTheForm('templateForm');
    },
    taskCheckboxChanged(task) {
      //FG - FOOF - TWO THINGS:
      //1) I could not get the validation rules to trigger when one of the custom buttons
      //was clicked so this is my hack
      //2) I'm sure there is a better way to do the validation but I
      //couldn't get the validation to work on the form item alone so I finally
      //gave up and I just validate the entire form.
      this.validateTheForm('templateForm');
    },
    validateMaintenance(rule,aMaint,callback) {
      let context = this
      if(aMaint.LogTemplateMaintenanceValue==false)
        if(aMaint.UserComment == null || aMaint.UserComment.trim().length<1) {
          callback(new Error("Comment is required"))
          context.allowSubmit = false
        }
    },
    validateTask(rule,aTask,callback) {
      let context = this
      if(aTask.LogTemplateTaskValue==false)
        if(aTask.UserComment == null || aTask.UserComment.trim().length<1) {
          callback(new Error("Comment is required"))
          context.allowSubmit = false
        }
    },
    validateReading(rule,aReading,callback) {
      //IGNORE NULLS
      if(aReading.LogTemplateReadingValue==null)
        return;
      let context = this;
      //check to see if reading value a number and does not have a significant digit after the 
      //max. number of dec. places allowed
      //NOTE: the checkNumberOfDecimalPlaces function first checks to be sure the value is a number so
      //      the isANumber function is not specifically called here
      var objectFromEdit = this.$hydrowareCommonJS.checkNumberOfDecimalPlaces(aReading.LogTemplateReadingValue,aReading.DecimalMarker)
      if(!objectFromEdit.OK) {
        //if the edit check fails then there is no need to continue and we do not replace the 
        //reading value with the FORMATTED_VALUE returned from the edit method
        context.allowSubmit=false
        callback(new Error(objectFromEdit.DETAILS.MSG))
        return
      }

      //So far so good - the value is a number with no significant digits after decimal marker
      //Replace the reading value with the FORMATTED_VALUE returned from the edit check
      aReading.LogTemplateReadingValue=objectFromEdit.DETAILS.FORMATTED_VALUE
      
      //Is the reading value within its range (If not this doesn't stop submit)  
      var rtnMsg = this.checkRange(aReading);

      //If the value is out of range then rtnMsg will be a string.
      //This will not stop the value from being stored.
      if(rtnMsg != null) 
        callback(new Error(rtnMsg))
    },
    checkRange(aReading) {
      let context = this
      var msgToReturn = null;
      var outOfRangeMsg = "Out of range";
      if(aReading.LogTemplateReadingValue) { 
        if(context.editableTabs.IsIdealRange) {
          if(aReading.LogTemplateReadingValue  <  aReading.IdealLow
             || aReading.LogTemplateReadingValue  >  aReading.IdealHigh) {
              msgToReturn = outOfRangeMsg;
          }
        }
        else {
          if(aReading.LogTemplateReadingValue  <  aReading.Low
            || aReading.LogTemplateReadingValue  >  aReading.High) {
              msgToReturn = outOfRangeMsg;
          }
        } 
      }
      return msgToReturn;
    },

    rediectToDashboard() {
      this.$router.push('dashboard')
    },

    cancel() {
      this.addRecord = false
      this.listRecord = true
      this.isAddingOrEditing=""
    },
    cancelpopup() {
      this.viewChemical = true

    },

    loadMorecall(id) {
      let context = this
      loader.startLoader()

      this.loadmore.skip = context.chemicalRecords.length
      this.loadmore.take = context.chemicalRecords.length + 10
      service.GetChemicalRecords(id, this.loadmore.skip, this.loadmore.take).then(function (response) {

//FG - FOOF - After Cert - First Release Security (7) Can the user at least view the data ?
if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
  context.chemicalRecords = []
  return;
}
//FG - FOOF - After Cert - First Release Security (7) - above



        loader.stopLoader()
        if (response) {

          response.map(function (el) {
            context.chemicalRecords.push(el)
          })
          context.countlength = response.length
        }

      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetChemicalRecords(id) {
      let context = this
      loader.startLoader()

      service.GetChemicalRecords(id, '', '').then(function (response) {

//FG - FOOF - After Cert - First Release Security (7) Can the user at least view the data ?
if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
  context.chemicalRecords = []
  return;
}
//FG - FOOF - After Cert - First Release Security (7) - above



        loader.stopLoader()
        context.chemicalRecords = []
        context.chemicalRecords = response ? response : []
        tooltip.startTooltip(50)
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    LoadMore() {

      this.loadmore.skip = this.loadmore.skip + 10
      this.loadmore.take = this.loadmore.take + 10
      this.loadMorecall(this.locationName)

    },

    AddChemicals() {
      $('#AddChecklistModal').modal('show')
      this.recordForm = {
        Id: '',
        StandardCodeId: '',
        ChemicalChecklistId: '',
        PoolId: '',
        Notes: '',

        ChemicalRecordValues: [],
        Warning: '',
        Label: ''

      }
      this.chemicalDetails = []
      this.$refs.templateForm.resetFields();
      this.isAddingOrEditing="A"
    },
    edit() {
      this.addRecord = true
      this.addRecordbutton = false
      this.isAddingOrEditing="E"
      alert("edit func---isAddingOrEditing: " + this.isAddingOrEditing)
    },
    Proceed() {
      this.listRecord = false
      this.addRecord = true
      this.addRecordbutton = true
      this.isAddingOrEditing = "A"
      $('#AddChecklistModal').modal('hide')

      let context = this
      this.GetPools(this.cheklistLocation.LocationId)
      this.GetStandards(this.cheklistLocation.LocationId)
      loader.startLoader()
      this.recordForm.ChemicalChecklistId = this.checklistName.Id

      service.GetChemicalChecklistDetails(this.checklistName.Id).then(function (response) {
        loader.stopLoader()

        context.chemicalDetails = response ? response : []
        if (context.chemicalDetails.Chemicals.length > 0) {

          context.chemicalDetails.Chemicals.map(function (el) {

            context.recordForm.ChemicalRecordValues.push({
              ChemicalId: el.ChemicalId,
              ChemicalValue: '',
              Warning: '',
              Wmessage: '',
              Label: ''
            })

          })
          context.recordForm.ChemicalRecordValues.map(function (el, index) {
            if (el.ChemicalValue == '') {
              context.isEmpty = true
            }

          })

        }

      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })

    },

    getTem(tempid) {
      let context = this
      service.GetLogTemplateById(tempid).then(function (response) {
        loader.stopLoader()
        //this.chemicalRecordDetails
        if (response.Pools.length > 0) {
          response.Pools.unshift(response.LocationRM)
        } else {
          response.Pools.push(response.LocationRM)
        }
        context.editableTabs['Pools'] = response.Pools
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    Proceed1(tempid) {
      this.listRecord = false
      this.addRecord = true
      this.addRecordbutton = true
      this.addRecordbutton="A"
      $('#AddChecklistModal').modal('hide')
      let context = this
      context.templateForm = {
        LogTemplateId: '',
        TemplateReadings: [],
        TemplateMaintenance: [],
        TemplateTasks: [],
        TemplateNotes: []
      }
      service.GetLogTemplateById(tempid).then(function (response) {

        loader.stopLoader()
        context.editableTabs = response
        if (response.Pools.length > 0) {
          response.Pools.map(function (item, index) {
          });
        }
        response.Pools.map(function (item, index) {
          item.LogReadings.map(function (item1, index1) {
            context.templateForm.TemplateReadings.push({
              'LogReadingId': item1.LogReadingsId,
              'LogName': item1.LogReadingsName,
              'UoM': item1.UoM,
              'LogTemplateReadingId': item1.Id,
              'PoolId': item.PoolId,
              'LogTemplateReadingValue': null,
              'IsRange': '',
              'IdealLow': item1.IdealLow,
              'IdealHigh': item1.IdealHigh,
              'High': item1.High,
              'Low': item1.Low,
              'DecimalMarker': item1.DecimalMarker
            })
          })
          item.LogMaintenances.map(function (item2, index2) {
            context.templateForm.TemplateMaintenance.push({
              'LogTemplateMaintenanceId': item2.Id,
              'MaintenanceName': item2.LogMaintenanceName,
              'PoolId': item.PoolId,
              'LogTemplateMaintenanceValue': null,
              'UserComment': ''

            })

          })

          item.LogTasks.map(function (item2, index2) {
            context.templateForm.TemplateTasks.push({
              'LogTemplateTaskId': item2.Id,
              'TaskName': item2.LogTaskName,
              'PoolId': item.PoolId,
              'LogTemplateTaskValue': null,
              'UserComment': ''

            })

          })

          context.templateForm.TemplateNotes.push({

            'PoolId': item.PoolId,
            'ReadingsNotes': '',
            'MaintenanceNotes': '',
            'TaskNotes': ''

          })

        })

      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetPools(id) {
      let context = this
      loader.startLoader()
      service.GetPools(id).then(function (response) {
        loader.stopLoader()
        context.pools = response ? response : []
        if (!context.recordForm['PoolId']) {
          context.recordForm.PoolId = context.pools[0].PoolId
        }

      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })

    },

    AddChemicalRecord() {
      var validate = true
      let context = this
      let error = false
      let isFocsed = false

      this.templateForUpload.LogTemplateId = this.templateForm.LogTemplateId;
      this.templateForUpload.TemplateReadings = this.templateForm.TemplateReadings
      this.templateForUpload.TemplateMaintenance = []
      this.templateForUpload.TemplateNotes = this.templateForm.TemplateNotes

      this.templateForm.TemplateMaintenance.forEach(function (template) {
        if (template.LogTemplateMaintenanceValue === false && (template.UserComment == null || template.UserComment == "")) {
          error = true
          if (isFocsed === false) {
            $('#' + template.LogTemplateMaintenanceId).find('input').focus()
          }
          isFocsed = true
        }
        context.templateForUpload.TemplateMaintenance.push(template)
      })

      this.templateForm.TemplateTasks.forEach(function (template) {
        if (template.LogTemplateTaskValue === false && (template.UserComment == null || template.UserComment == "")) {
          error = true
          if (isFocsed === false) {
            $('#' + template.LogTemplateTaskId).find('input').focus()
          }
          isFocsed = true
        }
        var foofMaintFromTask = {
              'LogTemplateMaintenanceId': template.LogTemplateTaskId,
              'MaintenanceName': template.TaskName ? template.TaskName : template.LogTaskName,
              'PoolId': template.PoolId,
              'LogTemplateMaintenanceValue': template.LogTemplateTaskValue,
              'UserComment': template.UserComment
        }
        context.templateForUpload.TemplateMaintenance.push(foofMaintFromTask);
      })

      if (error === false) {
        loader.startLoader()
        this.templateForm['LogTemplateId'] = this.checklistName.Id
        this.templateForUpload['LogTemplateId'] = this.checklistName.Id
        service.AddChemicalRecord(this.templateForUpload).then(function (response) {

          loader.stopLoader()
        
          //FG - FOOF - After Cert - First Release Security - added conditional statement below
          //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
          if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
            return;

          context.$notify({
            title: 'Success',
            message: 'Log  Created',
            type: 'success'
          })
          context.listRecord = true
          context.addRecord = false
          context.GetChemicalRecords(context.locationName)
          // context.GetChemicalRecords(context.locationName)
        }, (error) => {
          loader.stopLoader()
          this.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        })
      } else {
        this.$notify({
          title: 'Error',
          message: 'Further Details are Required',
          type: 'error'
        })
      }
    },

    validateTheForm(formName) {
      this.allowSubmit=true;
      this.$refs[formName].validate((valid) => {});
      return this.allowSubmit
    },

    UpdateChemicalRecord() {
      var okToSubmit = this.validateTheForm('templateForm');
      if(!okToSubmit) {
        //FG - FOOF - After Cert - First Release (5) - flipped the order of parms msg and ttl
        var optionsToUse = {
          title: "Fix Problems",
          message: "Fix the problems that are indicated and try again.  NOTE: They may be on any of the tabs.",
        }
        this.$hydrowareCommonJS.displayPopupMessage(this, optionsToUse)
        /* CODE BELOW IS PRIOR TO CERTIFICATION
        this.$hydrowareCommonJS.displayPopupMessage(
          this, 
          "Fix the problems that are indicated and try again.  NOTE: They may be on any of the tabs."
          "Fix Problems" //TITLE
        );
        */
        return;
      }
      let context = this
      let error = false
      let isFocsed = false

      this.templateForUpload.Id = this.templateForm.Id;
      this.templateForUpload.LogTemplateId = this.templateForm.LogTemplateId;
      this.templateForUpload.TemplateReadings = this.templateForm.TemplateReadings
      this.templateForUpload.TemplateMaintenance = []
      this.templateForUpload.TemplateNotes = this.templateForm.TemplateNotes

      this.templateForm.TemplateMaintenance.forEach(function (template) {;
        if (template.LogTemplateMaintenanceValue === false && (template.UserComment == null || template.UserComment == "")) {
          error = true
          if (isFocsed === false) {
            $('#' + template.LogTemplateMaintenanceId).find('input').focus()
          }
          isFocsed = true
        }
        context.templateForUpload.TemplateMaintenance.push(template)
      })

      this.templateForm.TemplateTasks.forEach(function (template) {;
        if (template.LogTemplateTaskValue === false && (template.UserComment == null || template.UserComment == "")) {
          error = true
          if (isFocsed === false) {
            $('#' + template.LogTemplateTaskId).find('input').focus()
          }
          isFocsed = true
        }
        var foofMaintFromTask = {
          'Id': template.Id,
          'LogTemplateMaintenanceId': template.LogTemplateTaskId,
          'MaintenanceName': template.TaskName ? template.TaskName : template.LogTaskName,
          'PoolId': template.PoolId,
          'LogTemplateMaintenanceValue': template.LogTemplateTaskValue,
          'UserComment': template.UserComment
        }
        context.templateForUpload.TemplateMaintenance.push(foofMaintFromTask);
      })

      if (error === false) {
        loader.startLoader()
        service.UpdateChemicalRecord(this.templateForUpload).then(function (response) {

        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
          return;

          loader.stopLoader()
          context.$notify({
            title: 'Success',
            message: 'Log updated',
            type: 'success'
          })
          context.listRecord = true
          context.addRecord = false
          context.GetChemicalRecords(context.locationName)
        }, (error) => {
          loader.stopLoader()
          this.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        })
      } else {
        this.$notify({
          title: 'Error',
          message: 'Further Details are Required',
          type: 'error'
        })
      }
    },

    GetStandards(id) {
      let context = this
      loader.startLoader()
      service.GetStandards(id).then(function (response) {
        loader.stopLoader()
        context.standards = response ? response : []
        if (!context.recordForm['StandardCodeId']) {
          context.recordForm.StandardCodeId = context.standards[0].Id
          context.recordForm.StandardCodeName = context.standards[0].Name
        }

      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })

    },
    GetChemicalChecklist(id) {
      let context = this
      loader.startLoader()
      service.GetChemicalChecklist(id).then(function (response) {
        loader.stopLoader()
        if (response) {
          if (response.length > 0) {
            response.map(function (el, index) {
              if (el.IsActive == false) {
                response.splice(index, 1)
              }
            })
          }
        }
        context.checklists = response ? response : []
        if (context.checklists.length > 0) {
          context.checklistName = context.checklists[0]
        } else {
          context.checklistName = ''
        }

      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    GetChemicalRecordDetails(id) {
      let context = this
      loader.startLoader()
      service.GetChemicalRecordDetails(id).then(function (response) {
        loader.stopLoader()

        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
          return;

        context.editableTabs = response
        context.templateName = response.Name
        context.templateForm = {
          LogTemplateId: '',
          TemplateReadings: [],
          TemplateMaintenance: [],
          TemplateTasks: [],
          TemplateNotes: []

        }
        response.Pools.map(function (item, index) {
          item.LogReadings.map(function (item1, index1) {
            context.templateForm.TemplateReadings.push({
              'Id': item1.EntryReadingId,
              'LogReadingId': item1.LogReadingsId,
              'LogName': item1.LogReadingsName,
              'LogTemplateReadingId': item1.Id,
              'UoM': item1.UoM,
              'PoolId': item.PoolId,
              'LogTemplateReadingValue': item1.LogTemplateReadingValue,
              'IsRange': item1.IsRange,
              'IdealLow': item1.IdealLow,
              'IdealHigh': item1.IdealHigh,
              'High': item1.High,
              'Low': item1.Low,
              'DecimalMarker': item1.DecimalMarker

            })
          })
          item.LogMaintenances.map(function (item2, index2) {
            context.templateForm.TemplateMaintenance.push({
              'Id': item2.EntryMaintenanceId,
              'LogTemplateMaintenanceId': item2.Id,
              'MaintenanceName': item2.MaintenanceName ? item2.MaintenanceName : item2.LogMaintenanceName,
              'PoolId': item.PoolId,
              'LogTemplateMaintenanceValue': item2.LogTemplateMaintenanceValue,
              'UserComment': item2.UserComment

            })
          })
          item.LogTasks.map(function (item2, index2) {
              context.templateForm.TemplateTasks.push({
                'Id': item2.EntryTaskId,
                'LogTemplateTaskId': item2.Id,
                'TaskName': item2.TaskName ? item2.TaskName : item2.LogTaskName,
                'PoolId': item.PoolId,
                'LogTemplateTaskValue': item2.LogTemplateTaskValue,
                'UserComment': item2.UserComment
  
              })
          })

          context.templateForm.TemplateNotes.push({
            'Id': item.EntryNotesId,
            'PoolId': item.PoolId,
            'ReadingsNotes': item.ReadingsNotes,
            'MaintenanceNotes': item.MaintenanceNotes,
            'TaskNotes': item.TaskNotes
          })

        })
        context.templateForm['Id'] = id
        context.listRecord = false
        context.addRecord = true
        context.addRecordbutton = false 
        context.isAddingOrEditing = "E"
        
        context.$nextTick(() => {
          context.$refs['templateForm'].validate((valid) => {})
        });
        

      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    backClick() {
      this.listRecord = true
    },
    GetLocations() {
      let context = this
      loader.startLoader()
      service.GetLocations().then(function (response) {
        loader.stopLoader()
        context.Locations = response ? response : []
        context.locationName = context.Locations[0].LocationId
        context.cheklistLocation = context.Locations[0]

        if (context.Locations[0].LocationId) {
          context.GetChemicalRecords(context.Locations[0].LocationId)
          context.GetChemicalChecklist(context.Locations[0].LocationId)

        }
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    locationChanged(locationName) {
      let context = this
      if (this.Firstloading) {
        this.loadmore.skip = ''
        this.loadmore.take = ''
        this.chemicalRecords = []
        this.recordBackup = []
        this.GetChemicalRecords(locationName)
        this.Locations.filter(function (item) {
          if (item.LocationId == locationName) {
            context.headerLocationName = item.LocationName
          }
        })

      } else {
        this.Firstloading = true
      }
    },
    ongetChecklist(aChecklistLocation) {
      if (aChecklistLocation.LocationId) {
        this.GetChemicalChecklist(aChecklistLocation.LocationId)
      }

    },

    //FG - FOOF - After Cert - First Release (6) - made confirm code consistent with new code (BELOW)
    del(id) {
      let context = this
      var aName = context.$data.checklistName.Name;
      var opts = {message: 'Are you sure you want to delete the Readings and Tasks Log: '+aName+'?'}      
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteAReadingsAndTasksLog.bind(null,id))
    },
    
    deleteAReadingsAndTasksLog(id) {
      var context = this;
      loader.startLoader()
      service.DeleteChemicalRecord(id).then(function (response) {

        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
          return;

        loader.stopLoader()
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
        context.GetChemicalRecords(context.locationName)
      }, (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },
    //FG - FOOF - After Cert - First Release (6) - made confirm code consistent with new code (ABOVE)

    markMaintenanceNotDone(status) {
      if (status.LogTemplateMaintenanceValue === false) {
        this.$notify({
          title: '',
          message: 'Further Details are Required',
          type: 'warning'
        })
      }
    },
    markTaskNotDone(status) {
      if (status.LogTemplateTaskValue === false) {
        this.$notify({
          title: '',
          message: 'Further Details are Required',
          type: 'warning'
        })
      }
    }
  },

  watch: {
    addRecord: function (val) {
      this.$router.app.$emit('sidebar_hide', val)
    },
    '$route' (to, from) {

      this.stateName = to.name
      if (from.name == 'chemicalrecord') {

        this.cancel()
      }
    }
  },

}



// WEBPACK FOOTER //
// ./src/components/ChemicalRecord/chemicalrecord.controller.js